import ROGBackground from "@components/layout/rog-background";
import { ACCESS_TOKEN } from "@pma/utils/constants";
import {
  DASHBOARD_PAGE_ROUTE,
  INVITATIONS_PAGE_ROUTE,
  LOGIN_PAGE_ROUTE,
} from "@pma/utils/page-routes";
import { parseCookies } from "nookies";
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();
  const isAuth = !!parseCookies()[ACCESS_TOKEN];

  const inviteParam = useSearchParams()[0].get("invitation_key");

  useEffect(() => {
    // Process user invitation
    if (inviteParam) {
      navigate(INVITATIONS_PAGE_ROUTE + `?key=${inviteParam}`);
    } else {
      //  Route user from `/` path based on their authentication state
      if (isAuth) {
        navigate(DASHBOARD_PAGE_ROUTE);
      } else {
        navigate(LOGIN_PAGE_ROUTE);
      }
    }
  }, []);
  return (
    <ROGBackground>
      <></>
    </ROGBackground>
  );
};

export default LandingPage;
